import { Box, Button, FormControl, Modal, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import RolePermissionAccordian from '../../RolePermissionAccordian';
import rolePermissionData, { permissionslabel } from '../../../utils/RoleData';
import { AddRoleData, UpdateRoleDetailsById } from '../../../network/Role';

const useStyles = makeStyles({
  customDashCard: {
    background: '#FFFFFF',
    boxShadow: '10px 10px 19px 1px #EAEAFF',
    borderRadius: '20px',
    minHeight: '190px'
  }
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: { xs: '70%', md: '40%' },
  maxWidth: { xs: '70%', md: '40%' },
  width: '35%',
  bgcolor: 'background.paper',
  p: 2,
  borderRadius: 1,
  maxHeight: '90vh'
};

export default function AddNewRoleModal({
  openAssignedModal,
  handleClose,
  onAction,
  setAlertMetas,
  alertMetas,
  selectedRoleData,
  setSelectedRoleData
}) {
  const classes = useStyles();
  const [createRoleStepNo, setCreateRoleStepNo] = useState('1');
  const [errors, setErrors] = useState(false);

  const validate = () => {
    const tempErrors = {};
    if (!roleData.name) tempErrors.name = 'Name is required';
    if (!roleData.description) tempErrors.description = 'Description is required';
    setErrors(tempErrors);

    return Object.keys(tempErrors).length === 0;
  };

  const [roleData, setRoleData] = useState({
    name: '',
    description: ''
  });

  const [accordianData, setAccordianData] = useState(rolePermissionData);

  const getLabelName = (label) => {
    switch (label) {
      case 'home':
        return 'Home Page';
      case 'trip':
        return 'Trip Page';
      case 'device':
        return 'Device Page';
      case 'route':
        return 'Route Page';
      case 'vehicle':
        return 'Vehicle Page';
      case 'roleManagement':
        return 'Role Management';
      case 'userManagement':
        return 'User Management';
      case 'controlCenter':
        return 'Control center page';
      default:
        break;
    }
  };

  const convertAccordionDataToPayload = (accordionData) => {
    const features = {};

    accordionData.forEach((page) => {
      const pageName = page.defaultName;
      features[pageName] = {};

      page.labelItems.forEach((item) => {
        features[pageName][item.value] = item.status;
      });
    });

    return features;
  };

  const checkValidation = () => {
    if (roleData?.name?.length === 0) {
      setErrors(true);
    } else {
      setErrors(false);
      setCreateRoleStepNo('2');
    }
  };

  const handleCreateRole = async (e) => {
    e.preventDefault();
    setErrors(false);

    const payload = {
      roleName: roleData.name.toLocaleLowerCase(),
      description: roleData.description,
      defaultPage: 'dashboard',
      pages: accordianData.map((page) => page.defaultName),
      features: [convertAccordionDataToPayload(accordianData)]
    };


    try {
      const res = (await selectedRoleData?.id)
        ? await UpdateRoleDetailsById(payload, selectedRoleData?.id)
        : await AddRoleData(payload);
      if (res) {
        setAlertMetas({
          ...alertMetas,
          severity: 'success',
          snackBarOpened: true,
          msg: selectedRoleData?.id ? 'Role Updated Successfully!!' : 'Role Created successfully !'
        });
        setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
        onAction();
        handleModalClose();
      }
    } catch (error) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    }
  };

  const handleModalClose = () => {
    handleClose();
    setSelectedRoleData({});
  };

  const handleChange = (name, value) => {
    setRoleData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  useEffect(() => {
    if (selectedRoleData?.id) {
      setRoleData({
        name: selectedRoleData.roleName,
        description: selectedRoleData.description || ''
      });
      setAccordianData(
        selectedRoleData?.pages?.map((pageName, index) => ({
          id: index + 1,
          label: getLabelName(pageName),
          defaultName: pageName,
          labelItems: Object.keys(selectedRoleData?.features[0][pageName] || {}).map(
            (featureKey, featureIndex) => ({
              id: featureKey,
              name: permissionslabel[0][featureKey] || featureKey,
              value: featureKey,
              status: selectedRoleData.features[0][pageName][featureKey] || false
            })
          )
        }))
      );
    }
  }, [selectedRoleData?.id]);

  return (
    <Box>
      <Modal
        open={openAssignedModal}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid="add-new-role"
      >
        <Box sx={style}>
          <Typography sx={{ fontSize: { xs: 16, md: 18 }, fontWeight: 900 }}>
            {selectedRoleData?.id ? 'Update Role' : 'Create New Role'}
          </Typography>
          {createRoleStepNo === '1' && (
            <Box>
              <FormControl data-testid="enter-role-formControl" fullWidth sx={{ mt: 2, mb: -2 }}>
                <TextField
                  label={
                    <Typography
                      sx={{
                        fontSize: {
                          xs: '12px',
                          sm: '14px'
                        },
                        fontWeight: 500
                      }}
                    >
                      Enter Role *
                    </Typography>
                  }
                  sx={{
                    '& .MuiOutlinedInput-input': {
                      fontSize: { xs: '12px', sm: '14px' },
                      padding: { xs: '14px 8px', sm: '16.5px' }
                    }
                  }}
                  name="name"
                  value={roleData.name}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  error={errors && roleData?.name?.length === 0}
                  helperText={errors && roleData?.name?.length === 0 ? 'Required' : ''}
                />
              </FormControl>
              <FormControl data-testid="role-description-formControl" fullWidth sx={{ mt: 3 }}>
                <TextField
                  label={
                    <Typography
                      sx={{
                        fontSize: {
                          xs: '12px',
                          sm: '14px'
                        },
                        fontWeight: 500
                      }}
                    >
                      Enter Role Description
                    </Typography>
                  }
                  sx={{
                    '& .MuiOutlinedInput-input': {
                      fontSize: { xs: '12px', sm: '14px' },
                      padding: { xs: '14px 8px', sm: '16.5px' }
                    }
                  }}
                  name="description"
                  value={roleData.description}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </FormControl>
              <Box sx={{ display: 'flex', float: 'right', flexWrap: 'wrap', mt: 3 }}>
                <Button variant="outlined" size="small" sx={{ mr: 2 }} onClick={handleModalClose}>
                  Cancel
                </Button>
                <Button variant="contained" size="small" onClick={checkValidation}>
                  Next
                </Button>
              </Box>
            </Box>
          )}
          {createRoleStepNo === '2' && (
            <Box sx={{ marginTop: '10px' }}>
              <RolePermissionAccordian
                handlePermissionChange={(name, value) => handleChange(name, value)}
                accordianData={accordianData}
                setAccordianData={setAccordianData}
              />
              <Box sx={{ display: 'flex', float: 'right', flexWrap: 'wrap', mt: 3 }}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{ mr: 2 }}
                  onClick={() => setCreateRoleStepNo('1')}
                >
                  Back
                </Button>
                <Button variant="contained" size="small" type="submit" onClick={handleCreateRole}>
                  {selectedRoleData?.id ? 'Save Changes' : 'Create Role'}
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Modal>
    </Box>
  );
}
